// ContactPickerModal.js
import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';

import API_BASE_URL from '../../../../Constants';

export default function ContactPickerModal({
  open,
  onClose,
  onAddRecipient,
  recipientType,
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (!open) return;

    async function fetchUsers() {
      try {
        const url = `${API_BASE_URL}/api/admin/users`;
        const resp = await fetch(url, { credentials: 'include' });
        if (!resp.ok) {
          throw new Error(`Failed to load user list => ${resp.status}`);
        }
        const data = await resp.json();
        setUserList(data);
      } catch (err) {
        console.error('Error fetching users =>', err);
        setUserList([]);
      }
    }
    fetchUsers();
  }, [open]);

  const filteredUsers = userList.filter((u) => {
    const text = `${u.username} ${u.email || ''}`.toLowerCase();
    return text.includes(searchTerm.toLowerCase());
  });

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-96 rounded shadow-lg p-4 relative">
        {/* Close icon */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-700 hover:text-gray-900"
        >
          <CloseIcon />
        </button>

        <h2 className="text-xl font-semibold mb-3 text-gray-800">
          Select {recipientType.toUpperCase()} Recipient
        </h2>

        {/* Search */}
        <div className="flex items-center mb-2">
          <div className="flex items-center bg-gray-100 border border-gray-300 rounded-l px-2">
            <SearchIcon className="text-gray-500" />
          </div>
          <input
            type="text"
            className="flex-1 border border-gray-300 rounded-r px-2 py-1 text-sm focus:outline-none"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* List of matching users */}
        <div className="max-h-64 overflow-y-auto border border-gray-200 rounded p-2">
          {filteredUsers.map((user) => {
            const displayName = user.username || `User #${user.id}`;
            const emailOrOther = user.email || '';
            return (
              <div
                key={user.id}
                className="flex justify-between items-center py-1 px-2 rounded hover:bg-blue-50 transition-colors"
              >
                <span className="text-sm text-gray-700">
                  {displayName} ({emailOrOther})
                </span>
                <button
                  onClick={() =>
                    onAddRecipient({
                      name: displayName,
                      email: emailOrOther,
                    })
                  }
                  className="text-blue-600 hover:text-blue-800"
                >
                  <AddIcon fontSize="small" />
                </button>
              </div>
            );
          })}

          {filteredUsers.length === 0 && (
            <p className="text-xs text-gray-400 text-center mt-2">
              No matching users found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}